import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

const VendorsDialogDelete = (props) => (
	<Dialog
		onClose={props.handleClose}
		aria-labelledby="vendor-dialog-delete-title"
		aria-describedby="vendor-dialog-delete-description"
		open={props.open}
		fullWidth
		maxWidth="xs"
	>
		<DialogTitle id="vendor-dialog-delete-title">
			<Translate id="vendors.dialogs.delete.title" />
		</DialogTitle>
		<DialogContent>
			<DialogContentText id="vendor-dialog-delete-description">
				<Typography>
					<Translate id="vendors.dialogs.delete.text" />
				</Typography>
			</DialogContentText>
			<DialogContentText>
				<Typography>{`${props.vendor.id} - ${props.vendor.name}`}</Typography>
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.handleClose} color="default" autoFocus>
				<Translate id="vendors.dialogs.close" />
			</Button>
			<Button onClick={props.submit} color="primary">
				<Translate id="vendors.dialogs.delete.submit" />
			</Button>
		</DialogActions>
	</Dialog>
);

export default withLocalize(VendorsDialogDelete);
